import {
  CardBank,
  CardBrand,
  CardType,
  OrderData,
  PaymentError,
  PaymentFormMerchantData,
  PaymentFormPaypalData,
  PaymentProcessSteps,
  PaymentType,
  RecurringData,
  ResignFormData,
} from '../entities';

export type PaymentsState = {
  paymentProcessStep: PaymentProcessSteps;
  paymentError: PaymentError | null;
  formMerchantData: PaymentFormMerchantData;
  formPaypalData: PaymentFormPaypalData;
  resignFormData: ResignFormData | null;
  recurringData: RecurringData | null;
  orderId: string;
  paymentCardBank: CardBank;
  paymentCardBrand: CardBrand;
  paymentCardType: CardType;
  orderData: OrderData;
  paymentType: PaymentType | null;
};

export const paymentsInitialState: PaymentsState = {
  paymentProcessStep: PaymentProcessSteps.IDLE,
  paymentError: null,
  formMerchantData: {
    paymentForm: {
      merchant: '',
      paymentIntent: '',
      signature: '',
    },
    paymentId: '',
  },
  formPaypalData: {
    paypalScriptUrl: '',
    paymentId: '',
  },
  resignFormData: null,
  orderId: '',
  recurringData: null,
  paymentCardBank: '',
  paymentCardBrand: CardBrand.UNKNOWN,
  paymentCardType: CardType.UNKNOWN,
  paymentType: null,
  orderData: {
    subjects: [
      {
        assigned_to: 'partner_1',
        birth_place: {
          place: '',
          longitude: 0,
          latitude: 0,
        },
        gender: '',
        birth_date: '',
        birth_time: '',
      },
      {
        assigned_to: 'partner_2',
        birth_place: {
          place: '',
          latitude: 0,
          longitude: 0,
        },
        gender: '',
        birth_date: '',
        birth_time: '',
      },
    ],
    reports: [],
    scan: {
      photoId: '',
    },
  },
};
